export default __webpack_public_path__ + "img/pin_icons/steam_b.svg";